import { render, staticRenderFns } from "./AddCustomHeaderTable.vue?vue&type=template&id=f9dc089e&scoped=true&"
import script from "./AddCustomHeaderTable.vue?vue&type=script&lang=js&"
export * from "./AddCustomHeaderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9dc089e",
  null
  
)

export default component.exports